import React, { FC } from 'react';
import translate from '@translate';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';
import WebhooksSettingsTopBlock from '../SettingsContainer/WebhooksSettingsTopBlock';
import { canRetryDelivery } from '../WebhookRecordsListContainer/functions';
import { WebhookDeliveryRowType } from 'src/types/webhookDeliveriesGrid';

type TopBlockProps = {
    data: WebhookDeliveryRowType | null;
    permissionUpdate: boolean;
    onReload: () => void;
    onRetry: () => void;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    const canRetry = props.data ? canRetryDelivery(props.data) : false;

    return (
        <WebhooksSettingsTopBlock
            actions={[
                {
                    onClick: props.onReload,
                    icon: <ReloadIcon />,
                    tooltip: translate('webhookRecordDetail.action.reload'),
                    variant: 'outlined',
                },
                {
                    onClick: props.onRetry,
                    icon: <ReloadIcon />,
                    label: translate('webhookRecords.action.retry'),
                    hidden: !props.permissionUpdate || !canRetry,
                },
            ]}
        />
    );
};

export default TopBlock;
